import { Rollset } from "@/pages/rollshop/models/Rollset";
import { getReadyRollsetsBySection } from "@/pages/rollshop/repositories/RollsetRepository";
import { useQuery } from "@tanstack/react-query";

export const useReadyRollsets = (sectionId: number) => {
	return useQuery<Rollset[], Error>({
		queryKey: ["readyRollsets", sectionId],
		meta: { realtime: ["M2.GetReadyRollsets"] },
		queryFn: ({ signal }) => {
			if (!sectionId) {
				return [];
			}
			return getReadyRollsetsBySection({ sectionId }, signal);
		},
	});
};
